import { headers } from "nats.ws";

export type CallContextFactory = (
  subject: string,
  action: string,
  payload: object,
  timeout?: number,
) => CallContext;

export interface CallContext extends Record<string, unknown> {
  subject: string;
  action: string;
  payload: object;
  correlationId: string;
  requestTimeout: number;
  issuedAt: string;
}

export function callContextFactory(modify: (context: CallContext) => void): CallContextFactory {
  return (subject: string, action: string, payload: object, timeout?: number) => {
    const context = {
      subject,
      payload,
      action,
      correlationId: "",
      requestTimeout: timeout || 15000,
      issuedAt: new Date().toISOString(),
    };
    modify(context);
    return context;
  };
}

export function natsHeaders(context: CallContext) {
  const callHeaders = headers();
  for (const [key, value] of Object.entries(createCallHeaders(context))) {
    callHeaders.append(key, value);
  }
  return callHeaders;
}

function createCallHeaders(context: CallContext) {
  return {
    "correlation-id": context.correlationId,
    client_version: "20220428r0",
    issued_at: context.issuedAt,
  };
}
